import { useMemo } from "react";

import { useCycleBudgetReviewDetails } from "../../../../api/hooks";

import { parseBudgetReviewsData } from "./utils";

import { useCompensationAccess } from "../../useCompensationAccess";

export const useCycleBudgetOverview = (cycleId: string | undefined) => {
	const {
		isLoading: isAccessLoading,
		compensationDisabled,
		canCreateCycle,
		compensationEnabled,
	} = useCompensationAccess(cycleId);

	const {
		data: cycleBudgetData,
		isLoading: isLoadingCycleBudgetData,
		isError: isErrorLoadingCycleBudgetData,
	} = useCycleBudgetReviewDetails(cycleId || "", {
		enabled: !!cycleId && !!compensationEnabled && !!canCreateCycle,
	});

	const cycle = cycleBudgetData?.compensationCycleData;
	let cycleStatus: string | undefined = cycle?.status;
	if (cycle?.displayStatus === "Scheduled") {
		cycleStatus = "scheduled";
	}

	const parsed = useMemo(() => parseBudgetReviewsData(cycleBudgetData), [cycleBudgetData]);

	const isLoading = !cycleId || isAccessLoading || compensationEnabled === undefined || isLoadingCycleBudgetData;
	const isForbidden = !isAccessLoading && (!canCreateCycle || !compensationEnabled || compensationDisabled);
	const isNotFound = !isLoading && (isErrorLoadingCycleBudgetData || !!cycle?.deletedAt);

	return {
		...parsed,
		cycleStatus,
		cycleBudgetData,
		isLoading,
		isForbidden,
		isNotFound,
	};
};
